import Message from 'messaging/models/Message'
import { computed, makeObservable } from 'mobx'
import { markdownToHtml } from 'utils/markdown-util'
import { MessageContentViewModel } from '../../../MessageViewModel'

/**
 * Text content.
 */
export class TextMessageContentViewModel implements MessageContentViewModel {
  constructor(public message: Message) {
    makeObservable(this)
  }

  /**
   * The rendered HTML content from Markdown.
   */
  @computed
  get htmlContent() {
    switch (this.message.content.type) {
      case 'Call':
      case 'Prompt':
      case 'Progression':
        return ''
    }

    return markdownToHtml(this.message.content.text)
  }
}
